<template>
  <div class="scene"  ref="vr_box" >
    <transition name="fade" mode="out-in" appear>
      <div v-if="!isReady" class="scene__loading">
        <img v-if="isMobile() ? imageMobile : imageDesktop"
             :src="isMobile() ? imageMobile : imageDesktop"
             class="scene__loading-background">
        <!-- Hide loading logo -->
        <!-- <img v-if="imageLogo" :src="imageLogo" class="vr-scene__loading-logo"> -->
        <div class="scene__loading-indicator">
          <div class="scene__loading-progress" :style="progressStyle" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import OwllyScene from "./OwllyScene";

export default {
  name: "VrScene",
    props: {
    sceneId: { type: String, required: true },
  },
 data() {
    return {
      disable: false,
      markerRotate: 0,
      flag: false,
      isTouching: false,
      canAutoReseting: false,
      isSkewing: false,
      isReady: false,
      imageDesktop: '',
      loadcount:0,
      progressStyle: {
        'max-width': '0'
      }
    }
  },
  methods: {
    async init() {

        this.getStoreInfo();
    },
    isMobile() {
      const regexp1 = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
      const regexp2 = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i;
      const target = navigator.userAgent || navigator.vendor || window.opera;
      return regexp1.test(target) || regexp2.test(target.substr(0, 4));
    },
  async getStoreInfo() {

        try {
          await this.$http.post(
            `/v1/get-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so`,
            // `http://192.168.90.101:8098/v1/get-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so`,
            { store_id: this.sceneId }
          ).then(async data => {

            this.storeInfo = data;
           await this.loadSceneData();
          });
        } catch (error) {
          this.$log(error.error_msg);
        }
      },
    async loadSceneData() {
      await this.$http.post(
        `/v1/list-panoramas?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so`,
        // `http://192.168.90.101:8098/v1/list-panoramas?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so`,
        { store_id: this.sceneId }
      ).then(data => {
        // console.log('data:',data.data.data.panorama_list);
        this.stage = new OwllyScene({container:this.$refs.vr_box,data:data.data.data});
        this.stage.addEventListener("load_moled",()=>{
         this.loadcount=this.loadcount+50;
         this.reSetloading();
        });

         this.stage.addEventListener("loaded_panorama",()=>{
          this.loadcount=this.loadcount+50;
          this.reSetloading();
        });

      });
    },
    reSetloading(){
        this.progressStyle = {
          'max-width': `${Math.floor(this.loadcount * 12.5)}rem`
        };
      if(this.loadcount>=100){
          setTimeout(() => {
            this.isReady = true;
          this.$emit('ready')
        }, 600);
      }
    },
  },
  async mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
  .scene {
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

  &__loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
  }

  &__loading-background {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__loading-logo {
    width: 9.375rem;
    height: 9.375rem;
    position: absolute;
    top: calc(50% - 4.6875rem);
    left: calc(50% - 4.6875rem);
    object-fit: cover;
  }

  &__loading-indicator {
    position: absolute;
    width: 12.5rem;
    height: .4rem;
    top: calc(50% - .2rem);
    left: calc(50% - 6.25rem);
    background-color: #3c3c3c;
    border-radius: .2rem;
  }

  &__loading-progress {
    position: absolute;
    height: .4rem;
    width: 12.5rem;
    top: 0;
    left: 0;
    background-color: white;
    border-radius: .2rem;
    transition: .2s;
  }
}

</style>
